import MsgEditor from './src/main';

/* istanbul ignore next */
MsgEditor.install = function(Vue) {
  Vue.component(MsgEditor.name, MsgEditor);
};

export default MsgEditor;
